// extracted by mini-css-extract-plugin
module.exports = {"form":"ProfileTab_form__XGaa-","photoWrapper":"ProfileTab_photoWrapper__1pri-","buttons":"ProfileTab_buttons__1wSQf","inputs":"ProfileTab_inputs__1qAJR"};